import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import {
  UpdateCongregation,
  CongregationUpdated,
  updateCongregation,
} from '~/generated';
import { extractData } from '~/utils/query-utils';

export const useEditCongregation = (
  id: number,
  options: UseMutationOptions<
    CongregationUpdated,
    unknown,
    UpdateCongregation,
    unknown
  >
) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (values: UpdateCongregation) => {
      const result = await extractData(
        updateCongregation({ body: { ...values, id } })
      );
      return result;
    },
    ...options,
    onSuccess(...args) {
      queryClient.invalidateQueries({
        queryKey: ['congregations'],
      });
      options.onSuccess?.(...args);
    },
  });
};
